module.exports = __webpack_public_path__ + "static/media/board.3fe9a9a6.png";